import { FunctionComponent, useState } from "react";
import GameBoard from "./GameBoard";
import { Player } from "./Types";
import PlayerCard, { PlayerCardSide } from "./PlayerCard";
import SettingsMenu from "./SettingsMenu";
import GameOverDialog from "./GameOverDialog";
import GameChat from "./GameChat";
import ForfeitMenu from "./ForfeitMenu";
import GameHUD from "./GameHUD";
import MoveTimer from "./MoveTimer";
import EmojiReactions from "./EmojiReactions";

type GameRoomProps = {
  playerPerspective: Player;
  lobbyDocId?: string;
};

const GameRoom: FunctionComponent<GameRoomProps> = ({
  playerPerspective,
  lobbyDocId,
}) => {
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <div className="Game-area-wrapper">
      {/* Модальные окна */}
      <SettingsMenu playerPerspective={playerPerspective} />
      <GameOverDialog playerPerspective={playerPerspective} />

      {/* 1. HUD — верхняя панель */}
      <GameHUD />
      <MoveTimer />

      {/* 2. Карточка соперника */}
      <PlayerCard side={PlayerCardSide.Top} playerPerspective={playerPerspective} />

      {/* 3. Доска — flex:1, заполняет середину */}
      <GameBoard playerPerspective={playerPerspective} />

      {/* 4. Карточка игрока */}
      <PlayerCard side={PlayerCardSide.Bottom} playerPerspective={playerPerspective} />

      {/* 5. Нижняя панель — сдаться + эмодзи + чат */}
      <div className="Game-bottom-bar">
        <ForfeitMenu />
        <div style={{ flex: 1 }} />
        <div className="Game-bottom-bar-trailing">
          <EmojiReactions lobbyDocId={lobbyDocId} />
          {!!lobbyDocId && (
            <GameChat
              lobbyDocId={lobbyDocId}
              isOpen={chatOpen}
              onToggle={() => setChatOpen((o) => !o)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default GameRoom;
